import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard-especialidades',
    imports: [],
    templateUrl: './dashboard-especialidades.html',
    styleUrl: './dashboard-especialidades.scss'
})
export class DashboardEspecialidades {}
